import { z } from "zod";

export const FilterSchema = z.object({
    filter: z.object({
        property_id: z.string().optional(),
        room_type_id: z
            .string()
            .optional()
            .refine((val) => !val || val.split(",").every((id) => id.length > 0), {
                message: "room_type_id must be a comma-separated list of valid IDs",
            }),
        periode: z.object({
            start: z.string().regex(/^\d{4}-\d{2}-\d{2}$/, {
                message: "periode.start must be in format YYYY-MM-DD",
            }),
            end: z.string().regex(/^\d{4}-\d{2}-\d{2}$/, {
                message: "periode.end must be in format YYYY-MM-DD",
            }),
        })
    }),
});

export type FilterSchemaType = z.infer<typeof FilterSchema>;